import Page from '../../base/collections/page';

export default Page.extend({
  state: {
    pageSize: 100,
    pagesInRange: 10
  },
  
  toggleIsDonation(checked, costcentre_id) {
    var model = this.get(costcentre_id);
    
    model.save({is_donation: checked}, {type: 'PATCH', url: this.urlBase + costcentre_id + '/'});
  }
});



// WEBPACK FOOTER //
// ./transactions/collections/costcentre.js